import React from 'react'
import Login from 'containers/login'

const LoginPage = () => <Login />

export default LoginPage
